module.exports = __webpack_public_path__ + "static/img/spherical.abcf538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spherical.png
// module id = AL3x
// module chunks = 1